import { Column, RowAlignedItems } from '@components/LinearLayout';
import { H1, H3, H4, P } from '@components/Typography';
import { EVENT_SECTION_WIDTH } from '@utils/constants';
import { styled } from 'styled-components';

export const TextLink = styled.a`
  color: ${({ theme }) => theme.color.mobilityBlue};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
`;

export const CenterText = styled(H4)<{ $color?: string }>`
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size20};
  text-align: center;
  max-width: 79rem;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    max-width: 60rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
    line-height: ${({ theme }) => theme.lineHeight.height115};

    padding: 0 2rem;
    max-width: 100%;
  }
`;

export const CenterTitle = styled(H1)<{ $color?: string }>`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size40};
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
    padding: 0 2rem;
    line-height: 5.4rem;
  }
`;

export const FilterContainer = styled(Column)`
  background-color: ${({ theme }) => theme.color.transparent};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};

  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`;

export const FiltersTitle = styled(H3)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size32};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  text-align: center;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
`;

export const FilterItems = styled(RowAlignedItems)`
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`;

export const EventSectionContainer = styled.div`
  width: min(${EVENT_SECTION_WIDTH}, 100%);
  margin: auto;
  padding-bottom: 5rem;
  padding-top: 5rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding-top: 0;
  }
`;

export const EventsTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0 2rem;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 0 3rem;
  }
`;

export const NoEvents = styled(P)<{ $color?: string }>`
  text-align: center;
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityGrey};
  word-wrap: break-word;
`;

export const BodyWrapper = styled(Column)`
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0 2rem;
  }
`;
